import { sdkLogger } from '../../logger/logger';
import { toSdkLoggableError } from '../../types/shared';
import type { RecordQuestionActivityRequestBody } from '../types';
import { buildRecordQuestionActivityUrl } from './url';

/**
 * Fire-and-forget POST to record question view activity.
 */
export async function recordQuestionActivity(
  instanceId: string,
  requestBody: RecordQuestionActivityRequestBody
): Promise<boolean> {
  const url = buildRecordQuestionActivityUrl(instanceId);

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(requestBody),
    });

    if (!response.ok) {
      sdkLogger.warn(`recordQuestionActivity failed (${response.status})`, { url, requestBody });
      return false;
    }

    sdkLogger.info('Question activity recorded', { questionIds: requestBody.questionIds });
    return true;
  } catch (err) {
    sdkLogger.warn('recordQuestionActivity request failed', { err: toSdkLoggableError(err) });
    return false;
  }
}
